import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-google-unlink-account-modal',
  templateUrl: './google-unlink-account-modal.component.html',
  styleUrls: ['./google-unlink-account-modal.component.scss']
})
export class GoogleUnlinkAccountModalComponent {
  constructor(
    private readonly userService: UserService,
    private readonly dialogRef: MatDialogRef<GoogleUnlinkAccountModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { email: string }
  ) {}

  confirm() {
    this.userService.unlinkGoogleAccountRequest().subscribe({
      next: (response) => {
        if (response.success) {
          this.dialogRef.close();
          this.userService.getUserInfo();
        }
      }
    });
  }
}
